import _ from 'underscore';
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';
import { SignupFlowStepLogger } from './signup-flow-step-logger';

export const SignupFlowStepLoggerWithActivity = ({
  flow, stepToPage, getSubFlowFromCurrentFlow, signUpPrefix,
}) => {
  const instrumentation = useContext(InstrumentationContext);
  const activity = useMemo(() => {
    if (instrumentation && instrumentation.signupFlowScenario) {
      const scenario = instrumentation.signupFlowScenario.create();
      return scenario.signupFlow.create();
    }
    return { trace: _.noop, error: _.noop };
  }, [instrumentation]);
  return (
    <SignupFlowStepLogger
      flow={flow}
      activity={activity}
      stepToPage={stepToPage}
      getSubFlowFromCurrentFlow={getSubFlowFromCurrentFlow}
      signUpPrefix={signUpPrefix}
    />
  );
};

SignupFlowStepLoggerWithActivity.propTypes = {
  flow: PropTypes.string.isRequired,
  stepToPage: PropTypes.shape({}).isRequired,
  getSubFlowFromCurrentFlow: PropTypes.func,
  signUpPrefix: PropTypes.string,
};
SignupFlowStepLoggerWithActivity.defaultProps = {
  signUpPrefix: 'signup_step_',
  getSubFlowFromCurrentFlow: () => null,
};
